'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

const SprintPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    // Reset visibility on route change
    setIsVisible(false);

    // Show popup after 3 seconds on every page load
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, [pathname]); // Re-run effect whenever pathname changes

  const handleDismiss = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className="fixed bottom-6 right-6 z-50 animate-slide-up"
      style={{
        animation: 'slideUp 0.5s ease-out',
      }}
    >
      <Link
        href="/ai-change-readiness-sprint"
        className="block bg-[#0A2540] text-white shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-105 max-w-sm"
      >
        <div className="relative p-6">
          {/* Dismiss Button */}
          <button
            onClick={handleDismiss}
            className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center hover:bg-white/10 transition-colors rounded-full"
            aria-label="Dismiss"
          >
            <Icon name="XMarkIcon" size={20} variant="solid" className="text-white" />
          </button>

          {/* Content */}
          <div className="pr-6">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
              <span className="text-xs font-bold font-cta tracking-wider uppercase text-white/80">Assessment Available</span>
            </div>
            
            <h3 className="text-xl font-bold font-headline text-white mb-2 leading-tight">
              AI Leadership Capability Snapshot
            </h3>
            
            <p className="text-sm text-white/90 font-body leading-relaxed mb-4">
              A 30-day diagnostic assessment benchmarking your organisation's readiness against the AI Change Leader Standard.
            </p>
            
            <div className="flex items-center gap-2 text-white font-semibold font-cta text-sm">
              <span>View Assessment</span>
              <Icon name="ArrowRightIcon" size={16} variant="solid" className="text-white" />
            </div>
          </div>

          {/* Decorative Element */}
          <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-blue-400 via-green-400 to-blue-400"></div>
        </div>
      </Link>

      <style jsx>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default SprintPopup;